// Shopify returns money amounts as Decimal *strings* ("0.00", "45.00"), so
// coerce before comparing: "0.00" is truthy, and Intl wants a number.
export function formatMoney(amount, currencyCode) {
  const value = Number(amount)
  if (!Number.isFinite(value)) return ''

  // Some items are given away rather than sold; "£0.00" reads as a pricing bug.
  if (value === 0) return 'Free'

  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
  }).format(value)
}
